import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

import Spinner from "@/components/Spinner";
// import { Dialog, Transition } from "@headlessui/react";
import { useState } from "react";
import toast from "react-hot-toast";

import FileUpload from "@/components/form/FileUpload";
import { applyCareer } from "@/services/api/Career";
import timezones from "@/utils/timezone.json";
import { RadioGroupIndicator } from "@radix-ui/react-radio-group";
import Datepicker from "react-tailwindcss-datepicker";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { ScrollArea } from "../ui/scroll-area";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Textarea } from "../ui/textarea";

const ApplyJob = ({ career }) => {
  let [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState({
    startDate: null,
    endDate: null,
  });
  const [isLoading, setLoading] = useState(false);
  const [full_name, setFullName] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [timezone, setTimezone] = useState("");
  const [location, setLocation] = useState("");
  const [nationality, setNationality] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const [gender, setGender] = useState(null);
  const [openCombobox, setOpenCombobox] = useState(false);

  const wordCount = message.trim().split(/\s+/).length;
  const wordLimit = 100;
  const isOverLimit = wordCount > wordLimit;

  const changeDatepickerValue = (newValue) => {
    setValue(newValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fileUrl) {
      return toast.error("Need to upload your latest CV.");
    }

    if (!gender) {
      return toast.error("Please select your gender.");
    }
    const payload = {
      career_id: career.id,
      full_name,
      email,
      whatsapp,
      phone,
      message,
      uploaded_cv: fileUrl,
      dob: value.startDate,
      location,
      nationality,
      timezone,
      linkedin_url: linkedin,
      gender,
    };

    setLoading(true);
    const res = await applyCareer(payload);
    if (res.status == 200 && res.data?.success) {
      toast.success("Your application has been sent. Thank you for applying.");
      setIsOpen(false);
      handleClear();
    } else {
      toast.error("There is an error! Try submit again.");
    }
    setLoading(false);
  };

  const handleClear = () => {
    setFullName(""),
      setEmail(""),
      setWhatsapp(""),
      setPhoneNumber(""),
      setMessage(""),
      setFileUrl(""),
      setValue(""),
      setLocation(""),
      setNationality(""),
      setTimezone(""),
      setLinkedin(""),
      setGender("");
  };

  const handleGenderChange = (value) => {
    setGender(value);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button className='w-full text-white bg-gradient-to-r from-red-1 to-yellow-1'>
          Apply this Position
        </Button>
      </DialogTrigger>
      <DialogContent className='max-h-screen overflow-y-auto bg-white text-background'>
        <DialogHeader>
          <DialogTitle className='text-left'>
            Apply for {career.job_title} Position
          </DialogTitle>
          <DialogDescription className='text-left'>
            <p className='font-medium text-background'>
              {career.employee_type} - {career.workplace_type}
            </p>
            <form
              onSubmit={handleSubmit}
              className='grid max-w-2xl grid-cols-12 pt-4 mt-4 text-left border-t gap-x-4 gap-y-5 border-background/20'
            >
              <div className='col-span-12 lg:col-span-6 flex flex-col gap-1.5'>
                <Label className='text-background'>
                  Full Name<span className='text-red-500'>*</span>
                </Label>
                <Input
                  type='text'
                  className='bg-white ring-offset-white border-background/20'
                  required
                  onInput={(evt) => setFullName(evt.target.value)}
                />
              </div>
              <div className='col-span-12 lg:col-span-6 flex flex-col gap-1.5'>
                <Label className='text-background'>
                  Email Address<span className='text-red-500'>*</span>
                </Label>
                <Input
                  type='email'
                  className='bg-white ring-offset-white border-background/20'
                  required
                  onInput={(evt) => setEmail(evt.target.value)}
                />
              </div>
              <div className='col-span-12 lg:col-span-6 flex flex-col gap-1.5'>
                <Label className='text-background'>
                  Phone Number<span className='text-red-500'>*</span>
                </Label>
                <Input
                  type='text'
                  className='bg-white ring-offset-white border-background/20'
                  required
                  onInput={(evt) => setPhoneNumber(evt.target.value)}
                />
              </div>
              <div className='col-span-12 lg:col-span-6 flex flex-col gap-1.5'>
                <Label className='text-background'>Whatsapp</Label>
                <Input
                  type='text'
                  className='bg-white ring-offset-white border-background/20'
                  required
                  onInput={(evt) => setPhoneNumber(evt.target.value)}
                />
              </div>
              <div className='col-span-12 lg:col-span-6 flex flex-col gap-1.5'>
                <Label className='text-background'>Birth Date</Label>
                <Datepicker
                  useRange={false}
                  asSingle={true}
                  value={value}
                  onChange={changeDatepickerValue}
                  inputClassName='bg-white border w-full rounded-md h-10 px-3 ring-offset-white border-background/20'
                />
              </div>
              <div className='col-span-12 lg:col-span-6 flex flex-col gap-1.5'>
                <Label className='text-background'>
                  Gender<span className='text-red-500'>*</span>
                </Label>
                <Select onValueChange={setGender} required>
                  <SelectTrigger className='border-background/20 ring-offset-white text-background bg-white'>
                    <SelectValue placeholder="Select gender" className="text-background" />
                  </SelectTrigger>
                  <SelectContent className="bg-white text-background">
                    <SelectItem 
                      value="male" 
                      className="text-background hover:bg-background/10 cursor-pointer"
                    >
                      Male
                    </SelectItem>
                    <SelectItem 
                      value="female" 
                      className="text-background hover:bg-background/10 cursor-pointer"
                    >
                      Female
                    </SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className='col-span-6 flex flex-col gap-1.5'>
                <Label className='text-background'>Nationality</Label>
                <Input
                  type='text'
                  className='bg-white ring-offset-white border-background/20'
                  required
                  onInput={(evt) => setNationality(evt.target.value)}
                />
              </div>
              <div className='col-span-6 flex flex-col gap-1.5'>
                <Label className='text-background'>Location (City)</Label>
                <Input
                  type='text'
                  className='bg-white ring-offset-white border-background/20'
                  required
                  onInput={(evt) => setLocation(evt.target.value)}
                />
              </div>
              <div className='col-span-12 flex flex-col gap-1.5'>
                <Label className='text-background'>Timezone</Label>
                <select
                  value={timezone}
                  onChange={(e) => setTimezone(e.target.value)}
                  className="w-full h-10 px-3 py-2 bg-white border rounded-md text-background border-background/20 focus:outline-none focus:ring-2 focus:ring-background/20"
                >
                  <option value="" disabled selected>Select timezone</option>
                  {timezones.map((time, index) => (
                    <option 
                      key={index} 
                      value={time.text}
                      className="text-background"
                    >
                      {time.text}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-span-12 flex flex-col gap-1.5'>
                <Label className='text-background'>
                  LinkedIn Profile<span className='text-red-500'>*</span>
                </Label>
                <Input
                  type='text'
                  className='bg-white ring-offset-white border-background/20'
                  placeholder='ex. https://www.linkedin.com/company/lucidity-insights/'
                  required
                  onInput={(evt) => setLinkedin(evt.target.value)}
                />
              </div>
              <div className='col-span-12 flex flex-col gap-1.5'>
                <Label className='text-background'>
                  Upload CV<span className='text-red-500'>*</span>
                </Label>
                <FileUpload setFileUrl={setFileUrl} fileUrl={fileUrl} />
              </div>
              <div className='col-span-12 flex flex-col gap-1.5'>
                <Label className='text-background'>
                  Message<span className='text-red-500'>*</span>
                </Label>
                <div className='relative'>
                  <Textarea
                    name='description'
                    required
                    rows='4'
                    onKeyDown={(event) => {
                      if (isOverLimit && event.key !== "Backspace") {
                        event.preventDefault();
                      } else {
                        setMessage(event.target.value);
                      }
                    }}
                    onChange={(event) => {
                      if (!isOverLimit) {
                        setMessage(event.target.value);
                      }
                    }}
                    className='bg-white text-background border-background/20 focus-visible:ring-0'
                  />
                  <span className='absolute z-10 text-xs bottom-2 right-2 text-white/30'>
                    Word Limit : {wordLimit + 1 - wordCount}
                  </span>
                </div>
                <p className='text-xs text-background/40'>
                  Tell us why we should consider you for the job
                </p>
              </div>
              <Button
                className='col-span-12'
                type='submit'
                variant='secondary'
                disabled={isLoading}
              >
                {isLoading && <Spinner />}
                {isLoading ? "Submiting ..." : "Submit"}
              </Button>
            </form>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default ApplyJob;
